import { useMemo, useState } from "react";
import thumbsUpIcon from "../assets/icons/thumbs-up-green.svg";
import warningTriangleIcon from "../assets/icons/warning-triangle.svg";
import WarningsModal from "./WarningsModal";
import { buildWarningMessageList } from "../utils/warnings";

const CaptureIssues = ({ assessment, isLoading }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const issues = useMemo(
    () => buildWarningMessageList(assessment),
    [assessment]
  );

  return (
    <>
      {!isLoading &&
        (issues.length > 0 ? (
          <div
            onClick={() => setIsModalOpen(true)}
            className="cursor-pointer flex items-center gap-1.5 text-xs font-semibold text-red-600 whitespace-nowrap"
          >
            <img alt="Warning" className="w-5 h-5" src={warningTriangleIcon} />
            {issues.length} Capture Issue{issues.length > 1 ? "s" : ""}
          </div>
        ) : (
          <div className="cursor-default flex items-center gap-1.5 text-xs font-semibold text-green-600 whitespace-nowrap">
            <img src={thumbsUpIcon} alt="thumbs-up" />
            No Capture Issues
          </div>
        ))}

      <WarningsModal
        isOpen={isModalOpen}
        warnings={issues}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default CaptureIssues;
